<div class="main">
    <div class="card-2 d-flex flex-dir-col gap-8">
        <div class="d-flex flex-dir-row just-space">
            <div class="d-flex" style="align-items: center;">
                <span class="h8 grey">Shift:&nbsp;</span> <span
                    *ngIf="response['tripDetails']['tripType']!=='Irregular' && response['tripDetails']['tripType']!=='Adhoc'"
                    class="h8-b">{{formattedShiftDate}}</span>
                <span *ngIf="response['tripDetails']['tripType']==='Irregular'"
                    class="h8-b">{{formattedActualStartDate}}</span>
                <span *ngIf="response['tripDetails']['tripType']==='Adhoc'" class="h8-b">ADHOC</span>
                <span class="h8-b" style="padding-left:5px">{{direction}}</span>
                <span style="margin-left: 5px" misToolTip text="Marshall Required" *ngIf="response['tripDetails']['ismarshalRequired']">
                    <img src="{{imgSrc}}assets/icons/marshall-with-bg.svg" alt="marhsall">
                </span>
                <img *ngIf="womenTravellingAlone" style="padding-left:5px"
                    src="{{imgSrc}}assets/icons/women-travel-alone.svg" />
            </div>


            <div class="status d-flex align-center">
                <span class="h-12 text-bold trip-status" [ngClass]="getTripStatusClass()">
                  {{ tripStatusTitle | titlecase }}
                  <img class="info-icon" *ngIf="tripStatusTitle !== 'STATUS UNAVAILABLE'" [src]="INFO_ICON" alt="" misToolTip [text]="tripStatusMessage" (position)="'bottom'">
                </span>
            </div>

        </div>


        <div class="d-flex flex-dir-col">
            <div class="d-flex gap-8">
                <div class="d-flex align-center"> <span class="h8 grey"> Planned:&nbsp;</span>
                    <span class="h8" *ngIf="response?.tripDetails['tripType']!=='Adhoc'">
                        {{formattedPlannedStartTime}}
                    </span>
                    &nbsp;-&nbsp;
                    <span class="h8"
                        *ngIf="response?.tripDetails['tripType']!=='Adhoc'">
                        {{formattedPlannedEndTime}}
                    </span>
                    <span class="h8" *ngIf="response?.tripDetails['tripType']==='Adhoc'">ADHOC</span>
                </div>
                <span *ngIf="response?.tripDetails['tripType']!=='Adhoc' && response?.tripDetails.actualStartTime"
                    class="grey"> | </span>
                <div *ngIf="response?.tripDetails['tripType']!=='Adhoc' ">
                    <span class="h8 grey"> Actual:</span>
                    <span class="h8" *ngIf="response?.tripDetails?.actualStartTime!==0 && response?.tripDetails?.status!==''">{{formattedActualStartTime}} - </span>
                    <span *ngIf="response?.tripDetails.actualStartTime===0 || response?.tripDetails?.status===''">&nbsp;--:-- - </span>
                    <span *ngIf="response?.tripDetails.actualStartTime!==0 && response?.tripDetails?.status==='Ended'" class="h8">{{formattedActualEndTime}}</span>
                    <span *ngIf="response?.tripDetails?.status!=='Ended'">--:--</span>
                </div>
                <!-- <div *ngIf="response?.tripDetails.actualEndTime!=null"><span class="h8">{{formattedEndDate}}</span><span class="h8-b"> {{formattedEndTime}}</span></div> -->
            </div>

            <!-- <div class="d-flex just-space">
                <span  misToolTip  [text]="response?.tripDetails.plannedStartLocation.address" [position]="'right'" style="max-width: 129px;" class="h8 grey truncate">{{response?.tripDetails.plannedStartLocation.address}}</span>
                <span  misToolTip  [text]="response?.tripDetails.plannedEndLocation.address" [position]="'bottom'" style="max-width: 129px;" class="h8 grey truncate">{{response?.tripDetails.plannedEndLocation.address}}</span>
            </div> -->
        </div>

    </div>

    <hr style="border: 0.5px solid lightgray;" />
    <div class="card-1 d-flex flex-dir-col">

        <div style="padding-bottom: 16px;"><span class="h8 grey">Vendor:&nbsp;</span>
            <span class="h8-b">{{response?.tripDetails.vehicle?.vendor?.name}}</span>
            <span class="h8-b" *ngIf="!response?.tripDetails.vehicle?.vendor?.name">Not Assigned</span>
        </div>

        <div
            [ngStyle]="{'filter': response?.tripDetails.vehicle?.vendor?.name ? 'none' : 'blur(5px)', 'opacity': response?.tripDetails.vehicle?.vendor?.name ? '1' : '0.7'}">

            <div class="d-flex flex-dir-row just-space" style="padding-bottom: 8px; border-bottom: 1px dashed #E0E0E0;">
                <div class="d-flex flex-dir-row gap-11">
                    <img style="width: 42px;height: 42px;border-radius: 50%;"
                        src="{{response?.tripDetails.driver?.driverImagePath}}"
                        *ngIf="response?.tripDetails.driver?.driverImagePath" />
                    <img style="width: 42px;height: 42px;border-radius: 50%;"
                        src="{{imgSrc}}assets/icons/driver-icon.svg"
                        *ngIf="!response?.tripDetails.driver?.driverImagePath" />
                    <div class="d-flex flex-dir-col">
                        <div class="d-flex flex-dir-row gap-8">
                            <span misToolTip [text]="response?.tripDetails.driver?.name" [position]="'bottom'"
                                class="h-16 text-bold lh-24 truncate max-width">{{response?.tripDetails.driver?.name}}</span>
                            <span class="h-16 lh-24 truncate" style="margin-top: 9px;"
                                *ngIf="!response?.tripDetails.driver?.name">Driver not
                                assigned</span>
                            <div class="vl grey" *ngIf="response?.tripDetails.driver?.name"></div>
                            <span class="d-flex h-12 align-center"
                                *ngIf="response?.tripDetails.driver?.phoneNumber"><img
                                    src="{{imgSrc}}assets/icons/call.svg" />{{response?.tripDetails.driver?.phoneNumber}}</span>
                        </div>


                        <span class="h9 d-flex"
                            *ngIf="response?.tripDetails.driver?.driverRating">{{response?.tripDetails.driver?.driverRating}}
                            <img style="margin-left:3px" src="{{imgSrc}}assets/icons/star.svg" /></span>

                    </div>
                </div>

                <button misToolTip [text]="'Device Health'" [position]="'right'" (click)="openDeviceHealthModal()"
                    class="transparent-button device pointer-cursor"><img src="{{imgSrc}}assets/icons/device-health.svg"
                        alt="" *ngIf="response?.tripDetails.driver?.name"></button>
            </div>

            <div style="padding-top:8px" class="d-flex flex-dir-row gap-8 align-center">


                <img style="width:45px;height:30px" src="{{imgSrc}}assets/icons/cab.svg" alt="">


                <div class="card-1-child-2 d-flex flex-dir-col just-space width-100">
                    <div class="d-flex flex-dir-row gap-8">
                        <span class="h8-b" misToolTip [text]="'Vehicle Number'"
                            [position]="'bottom'">{{response?.tripDetails.vehicle?.vehicleIdentification}}</span>
                        <span class="h8-b" *ngIf="!response?.tripDetails.vehicle?.vehicleIdentification">Vehicle not
                            assigned</span>

                        <div class="vl grey" *ngIf="response?.tripDetails.vehicle?.vehicleIdentification"></div>
                        <span class="h8" misToolTip [text]="'Vehicle ID'"
                            [position]="'bottom'">{{response?.tripDetails.vehicle?.vehicleId}}</span>
                        <div class="vl grey" *ngIf="response?.tripDetails.vehicle?.vehicleIdentification"></div>
                        <span class="h8" misToolTip [text]="'Vehicle Type'" [position]="'bottom'"
                            *ngIf="response?.tripDetails.vehicle?.vehicleIdentification">
                            {{response?.tripDetails.vehicle?.vehicleType?.type}}({{response?.tripDetails.vehicle?.vehicleType?.maxCapacity}})</span>
                        <!-- <div><span class="h8-b">{{response?.tripDetails.vehicle?.vehicleId}}</span><span class="h8"> &#183; {{response?.tripDetails.vehicle?.vehicleType?.name}}({{response?.tripDetails.vehicle?.vehicleType?.maxCapacity}}) &#183; {{response?.tripDetails.vehicle?.vehicleIdentification}}</span></div>
                    <div *ngIf="response?.tripDetails.ismarshalRequired"><span class="h8 grey">Marshall Requested</span></div>
                 -->
                    </div>

                    <!-- <div class="d-flex align-center just-space">
                    <div class="d-flex gap-16"><span misToolTip  [text]="response?.tripDetails.driver?.name" [position]="'bottom'" style="max-width: 60px;" class="h8 truncate">{{response?.tripDetails.driver?.name}}  </span> <span class="h8">{{response?.tripDetails.driver?.phoneNumber}}</span></div>
                    <button misToolTip  [text]="'Device Health'" [position]="'right'" (click)="openDeviceHealthModal()"  class="transparent-button device pointer-cursor"><img src="assets/icons/device-health.svg" alt=""></button>
                </div> -->

                    <span class="grey h9"> {{response?.tripDetails.vehicle?.vehicleType?.name}}</span>
                </div>
            </div>
            <div *ngIf="!response?.tripDetails.vehicle?.vendor?.name" class="white-overlay"></div>
        </div>


    </div>

    <div class="ticket-details" *ngIf="ticketDetails.length">

        <div class="ticket-details-header">Ticket Details</div>

        <div class="ticket-details-values">

           <div class="values-row" *ngFor="let ticket of ticketDetails">
            <span class="field-details">
                <span class="field-name">{{ticket.ticketType | titlecase}}</span>
                <span class="field-value">{{ticket.ticketId}}</span>
            </span>
                <span class="ticket-management-link" (click)="openTicketDetails(ticket.ticketUrl)">View Ticket</span>
           </div>
        </div>

    </div>


</div>
